import { DeductionsStoreType } from '@core/symbol';
import { OrderItem, OrderSideEnum } from '@libs/api-reference';
import { getOrderPrice } from './orderPrice';

const getSltpOrderWage = (order: OrderItem, wage: DeductionsStoreType) =>
  order.orderSideId === OrderSideEnum.Buy
    ? 1 + wage.buyValue
    : 1 - wage.sellValue;

const getSltpOrderValue = (
  order: OrderItem,
  wage: DeductionsStoreType,
  isDoneOrder: boolean
) =>
  isDoneOrder
    ? order.executedValue
    : (order?.targetQuantity ?? 0) *
      getOrderPrice(order) *
      getSltpOrderWage(order, wage);

const getSltpOrderQuantity = (
  order: OrderItem,
  wage: DeductionsStoreType,
  isDoneOrder: boolean
) =>
  isDoneOrder
    ? order.executedQuantity
    : Math.ceil(
        (order.investValue || 0) /
          (getOrderPrice(order) * getSltpOrderWage(order, wage))
      );

export { getSltpOrderQuantity, getSltpOrderValue, getSltpOrderWage };
